__turbopack_context__.v({
  "codeDemoWrapper": "utWsvG_codeDemoWrapper",
  "codeSnippetStyle": "utWsvG_codeSnippetStyle",
  "selectButton": "utWsvG_selectButton",
  "selectGroupWrapper": "utWsvG_selectGroupWrapper",
});
